import { convertStringToReactNodes } from "@tm/utils"

const HitHighlightPreTag = "<span class='highlight'>"
const HitHighlightPostTag = "</span>"

type Props = {
    children: string | undefined
}

export function AutocompleteHit({ children }: Props) {
    if (!children) {
        return null
    }

    return (
        // Fragment needed because "convertStringToReactNodes" returns an array of nodes
        <>
            {convertStringToReactNodes(children, HitHighlightPreTag, HitHighlightPostTag, (match, i) => (
                <strong key={i}>{match}</strong>
            ))}
        </>
    )
}
